export const snapToWordBoundary = (text: string, charIndex: number): number => {
  let index = Math.min(Math.max(charIndex, 0), text.length);

  while (index < text.length && /\s/.test(text[index])) {
    index += 1;
  }

  return index;
};
